import types from './types';

const INITIAL_STATE = {
    isPosting: false,

    result: [],
};

const authEnquireServiceReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.POST_ENQUIRE_SERVICE_REQUEST:
        return {
            ...state,
            result: [],
            isPosting: true,
        };

    case types.POST_ENQUIRE_SERVICE_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isPosting: false,
        };

    case types.POST_ENQUIRE_SERVICE_FAILURE:
        return {
            ...state,
            result: [],
            isPosting: false,
        };

    default:
      return state;
  }
};

export default authEnquireServiceReducer;
